<template>
  <div class="box-mini mb-15">
      <div class="p-15 table-responsive table-bordered">
              <table class="w-100 overflow-x">
                <tr>
                  <td></td>
                  <td v-for="date in generateWeekDates(setWeeks,dateTodayData) " :key="date" style="min-width: 100px; border: 1px solid #ccc; background-color: black; color:rgb(250, 173, 26);text-align: center;">
                      {{ date }}

                    </td>
                </tr>
                <tr v-for="time in pt_planner_time" :key="time.id">

                  <td style="background-color: white;min-width: 100px" class="px-2 py-3">
                    <span style="font-size:12px">{{ time.time_start.slice(0, -3) }} - {{ time.time_end.slice(0, -3) }}</span>
                  </td>
                  <td v-for="date in generateWeekDates(setWeeks,dateTodayData) " :key="`date` + date"
                  >
                    <div >
                      <leadsActivities :data="cekData(date,dataPlanner,sales_id,time.time_start,time.time_end)" />
                    </div>
                  </td>
                </tr>
          </table>

      </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import leadsActivities from './leads_activities.vue'

  export default {
    props:['itemSales','pt_planner_time','setWeeks','dateTodayData','dataPlanner','sales_id'],
    components: {
      leadsActivities
    },

    computed: {
      currentDate() {
        const date = new Date()
        const options = { weekday: 'long', day: 'numeric', month: 'short' }
        return date.toLocaleDateString('en-US', options)
      }
    },
    methods: {

      generateWeekDates(week, month) {
        let lastDateMonth = moment(month + '-01').endOf('month').format('D');
        const dates = [];
        let start_date = 1
        let lastDate = start_date + 6
        if (week == 2) {
          start_date = 8
          lastDate = start_date + 6
        } else if (week == 3) {
          start_date = 15
          lastDate = start_date + 6
        } else if (week == 4) {
          start_date = 22
          lastDate = start_date + 6
        } else if(week == 5) {
          if (lastDateMonth > 28) {
            start_date = 29
            lastDate = lastDateMonth

          } else {
            start_date = 0
            lastDate = 0
          }
        }
        if (lastDate != 0) {
          for (let index = start_date; index <= lastDate; index++) {
            let date = moment(month + '-01').date(index).format('dddd, D MMM');
            dates.push(date)

          }
        }


        return dates;
      },
      cekData(date,dataPl,sales_id,time,end) {
        let day = moment(date, 'dddd, D MMM').format('YYYY-MM-DD')
        console.log(day + " " + sales_id + " " + time.slice(0, -3))
        let data = dataPl.filter(x => x.owner_id == sales_id && x.due_date == day && x.start_time.slice(0, -6) == time.slice(0, -6) )
        if (typeof data !== 'undefined') {
          return data
        } else {
          return []

        }
      }
    }
  }
</script>
